import CryptoJS from "crypto-js";

export function encryptText(message, cryptoKey) {
  return CryptoJS.AES.encrypt(message, CryptoJS.enc.Base64.parse(cryptoKey), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
}

export function decrypt(message, key) {
  // if (key === undefined) {
  //     key = "cryptoKey";
  // }
  //convert key to base 64
  var cryptoKey = CryptoJS.enc.Base64.parse(key);

  return CryptoJS.AES.decrypt(message, cryptoKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
}
